// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"03ea8317","452":"6c14a971","701":"6f0b5bb9","860":"f5881062"}[chunkId] + ".chunk.js";
};